module.exports = __webpack_public_path__ + "img/detail_wait-print@2x.02214431.png";